import "core-js/modules/es.object.define-property";
import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';

var ParticipationModel =
/** @class */
function () {
  function ParticipationModel(raw) {
    this.id = raw.id;
    this.activity = raw.activity;
    this.team = raw.team;
    this["package"] = raw["package"];
    this.sign_up_start_date = raw.sign_up_start_date;
    this.sign_up_finish_date = raw.sign_up_finish_date;
    this.start_date = raw.start_date;
    this.finish_date = raw.finish_date;
    this.total_days = raw.total_days;
    this.train_level = raw.train_level;
    this.join_time = raw.join_time;
    this.join_index = raw.join_index;
    this.has_training_plan = raw.has_training_plan;
  }

  Object.defineProperty(ParticipationModel.prototype, "startParticipation", {
    /** 是否开始报名 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateParse(this.sign_up_start_date).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationModel.prototype, "closeParticipation", {
    /** 是否结束报名 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateOffset(dateParse(this.sign_up_finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationModel.prototype, "startSignIn", {
    /** 是否开始打卡 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateParse(this.start_date).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationModel.prototype, "closeSignIn", {
    /** 是否结束打卡 */
    get: function get() {
      var timestamp = serverDateNow().valueOf();
      return timestamp >= dateOffset(dateParse(this.finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationModel.prototype, "tag", {
    /** 标签文本 */
    get: function get() {
      if (!this.startParticipation) {
        return '未开始';
      } else if (!this.closeParticipation && !this.startSignIn) {
        return '报名中';
      } else if (this.startSignIn && !this.closeSignIn) {
        return '进行中';
      } else if (this.closeSignIn) {
        return '已结束';
      }
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(ParticipationModel.prototype, "isFinish", {
    /** 是否完赛 */
    get: function get() {
      return this.total_days >= this.activity.need_sign_in_days;
    },
    enumerable: false,
    configurable: true
  });
  return ParticipationModel;
}();

export { ParticipationModel };